export default {
  histories: [],
  studentFilter: [],
  origin: [],
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
};
